import React from "react";
import { EonUiLink } from "@eon-ui/eon-ui-components-react";
import "./footer.scss";
import { useTranslation } from "@me8eon/translation";
import { EnvironmentConfig } from "@me8eon/config";
import { useUserData } from "@me8eon/react_authentication";
import { useNavigate } from "react-router-dom";
import { useFeatureFlag } from "@me8eon/featureflags";
import { metaHumanFFName } from "../../pages/communicate/audio.feature.flag";

export const Footer: React.FC = () => {
    const t = useTranslation();
    const year = new Date().getFullYear();
    const { loggedIn } = useUserData();
    const navigate = useNavigate();
    const metaHumanFF = useFeatureFlag(metaHumanFFName);

    return (
        <div className="footer" data-testid="footer">
            <div className="white-section-footer">
                <div className="footer-left-right-spacing">
                    <div className="mid-footer">
                        <div className="footer-links">
                            <EonUiLink
                                data-testid="contact"
                                size="small"
                                slot="links"
                                target="_blank"
                                text={t("footer.contact")}
                                hideIcon={true}
                                href={`mailto:${EnvironmentConfig.meAtEonContactEmail}`}
                            ></EonUiLink>
                        </div>
                        {loggedIn &&
                            <div className="footer-links">
                                <EonUiLink
                                    id="tileTour2"
                                    data-testid="about-me8eon"
                                    size="small"
                                    slot="links"
                                    text={t("footer.aboutMe8EON")}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigate(`/about-myhelp?tab=0`);
                                    }}
                                    hideIcon={true}
                                    href="#"
                                ></EonUiLink>
                            </div>
                        }
                        {metaHumanFF && (
                            <div className="footer-links">
                                <EonUiLink
                                    size="small"
                                    slot="links"
                                    text={"Meta Human"}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        navigate(`/voice-assist`);
                                    }}
                                    hideIcon={true}
                                    href="#"
                                ></EonUiLink>
                            </div>
                        )}
                    </div>
                    <div className="right-footer">
                        <div className="eon-copyright">
                            {`© E.ON SE ${year}`}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

